import LegalDocsTabs from 'components/LegalDocsTabs'
import SEO from 'components/SEO'
import Heading from 'new-components/Heading'
import TextDanger from 'new-components/partnesComponents/TextDanger'
import * as Styles from './styles'
import { termsOfUseText } from './termsText'

function TermsOfUse() {
  return (
    <Styles.Container>
      <SEO
        title="Termos de Uso"
        description="Leia os termos de uso da plataforma Cannect. Informações sobre condições de uso, responsabilidades e direitos dos usuários."
        canonical="/termos-de-uso"
        noindex
      />
      <LegalDocsTabs />
      <Heading defaultColor="darkGrey">Termos de uso</Heading>
      <TextDanger text={termsOfUseText} />
    </Styles.Container>
  )
}

export default TermsOfUse
